import React from "react";

/**
 * DiligenceChangeModal - Confirmation modal specifically for diligence status changes
 * Shows current and new status with appropriate styling
 */
const DiligenceChangeModal = ({
  isOpen,
  onClose,
  onConfirm,
  currentStatus,
  newStatus
}) => {
  if (!isOpen) return null;

  const getStatusColor = (status) => {
    switch(status) {
      case "Enhanced": return "#dc3545";
      case "Simplified": return "#28a745";
      case "Standard": return "#007bff";
      default: return "#333";
    }
  };

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
          maxWidth: "500px",
          width: "90%",
        }}
      >
        <h2 style={{ margin: "0 0 15px 0", fontSize: "1.25rem", color: "#333" }}>
          ⚠️ Confirm Diligence Status Change
        </h2>

        <p style={{ fontSize: "14px", marginBottom: "15px", lineHeight: "1.5", color: "#666" }}>
          This request's diligence status will be marked as{" "}
          <strong style={{ color: getStatusColor(newStatus) }}>{newStatus}</strong>.
        </p>

        <div
          style={{
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            fontSize: "14px",
            marginBottom: "20px",
          }}
        >
          <strong>Current:</strong> {currentStatus || "N/A"} → <strong>New:</strong> {newStatus}
        </div>

        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              border: "1px solid #dc3545",
              background: "#fff",
              color: "#dc3545",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              minWidth: "90px",
              transition: "opacity 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "0.8")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "8px 16px",
              border: "none",
              background: "#059a99",
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              minWidth: "90px",
              transition: "opacity 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "0.8")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiligenceChangeModal;
